import { getCookie } from '../../features/home/app_util';
const Authorization = 'Bearer ' + getCookie('token');

export const builderSurfaceMultiPartHeader = (projectId) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
    'x-project-id': projectId,
  };
  if (Authorization) {
    headers['token'] = Authorization;
  }
  return { headers };
};

export const builderSurfaceJsonContentHeader = (projectId, userIp = '', envType = '') => {
  const headers = {
    'Content-Type': 'application/json',
    'x-project-id': projectId,
  };
  if (envType) {
    headers['x-project-env'] = envType;
  }
  if (Authorization) {
    headers['token'] = Authorization;
  }
  if (userIp) {
    headers['userIp'] = userIp;
  }
  return { headers };
};
